var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgCalculatorSolid = function SvgCalculatorSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "calculator-solid",
    d: "M12.5,0H1.5A1.538,1.538,0,0,0,0,1.5v13A1.538,1.538,0,0,0,1.5,16h11A1.538,1.538,0,0,0,14,14.5V1.5A1.538,1.538,0,0,0,12.5,0ZM4,13.6a.43.43,0,0,1-.4.4H2.4a.43.43,0,0,1-.4-.4V12.4a.43.43,0,0,1,.4-.4H3.6a.43.43,0,0,1,.4.4Zm0-4a.43.43,0,0,1-.4.4H2.4A.43.43,0,0,1,2,9.6V8.4A.43.43,0,0,1,2.4,8H3.6a.43.43,0,0,1,.4.4Zm4,4a.43.43,0,0,1-.4.4H6.4a.43.43,0,0,1-.4-.4V12.4a.43.43,0,0,1,.4-.4H7.6a.43.43,0,0,1,.4.4v1.2Zm0-4a.43.43,0,0,1-.4.4H6.4A.43.43,0,0,1,6,9.6V8.4A.43.43,0,0,1,6.4,8H7.6a.43.43,0,0,1,.4.4V9.6Zm4,4a.43.43,0,0,1-.4.4H10.4a.43.43,0,0,1-.4-.4V8.4a.43.43,0,0,1,.4-.4h1.2a.43.43,0,0,1,.4.4v5.2Zm0-8a.43.43,0,0,1-.4.4H2.4A.43.43,0,0,1,2,5.6V2.4A.43.43,0,0,1,2.4,2h9.2a.43.43,0,0,1,.4.4Z",
    fill: "#3c3e69"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCalculatorSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/calculator-solid.b7978b76.svg";
export { ForwardRef as ReactComponent };